// extracted by mini-css-extract-plugin
var _1 = "_TCvqH";
var _2 = "_KJGFf";
export { _1 as "checkbox", _2 as "checkboxLabel" }
